<template>
  <div id="calc" class="loan-calculator-short">
    <div class="row">
      <div class="col-sm-12">
        <div class="row">
          <div class="col-sm-3">
            <amortization-rate @change-amortization-rate="changeAmortizationRate"
                               :rates="rates"
                               :amortizationRate="amortizationRate"
            ></amortization-rate>
          </div>
          <div class="col-sm-3">
            <fixed-interest @change-fixed-interest="changeInterestRate"
                            :interests="interests"
                            :year="currentSelectedYear"
            ></fixed-interest>
          </div>
          <div class="col-sm-3 interest">
            <interest-information v-bind:interest="interest"></interest-information>
          </div>
          <div class="col-sm-3 total">
              <net-loan v-bind:netLoan="netLoan"></net-loan>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-3">
            <selling-price @change-selling-price="changeSellingPrice"
                           :sellingPrice="sellingPrice"></selling-price>
          </div>
          <div class="col-sm-3">
            <additional-costs @change-additional-costs="changeAdditionalCosts"
                              @show-modal="changeModal"
                              :additionalCosts="additionalCosts"
                              :sellingPriceChanged="sellingPriceChanged"
            ></additional-costs>
          </div>
          <div class="col-sm-3">
              <equity @change-equity="changeEquity"
                      :equity="equity"
                      :sellingPrice="sellingPrice"
              ></equity>
          </div>
          <div class="col-sm-3 interest-summary">
            <interest-information v-bind:interest="interest"></interest-information>
          </div>
          <div class="col-sm-3 total-summary">
            <net-loan v-bind:netLoan="netLoan"></net-loan>
          </div>
          <div class="col-sm-3 ">
            <rate :rate="rate"
                  :amortizationRate="amortizationRate"
                  :interest="interest"
                  :sellingPrice="sellingPrice"
                  :additionalCosts="additionalCosts"
                  :netLoan="netLoan"
                  :equity="equity"
                  :currentSelectedYear="currentSelectedYear"
            ></rate>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div>
    <ModalView @close-modal="changeModal"
               @additional-cost-calculated="additionalCostCalculated"
               @additional-cost-calculated-after-selling-price-change="additionalCostCalculatedAfterPriceChange"
               :showModal="showModal"
               :sellingPrice="sellingPrice"></ModalView>
  </div>
</template>
<script>
 import FixedInterest from "./components/FixedInterest";
 import AmortizationRate from "./components/AmortizationRate";
 import InterestInformation from "./components/InterestInformation";
 import SellingPrice from "./components/SellingPrice";
 import NetLoan from "./components/NetLoan";
 import AdditionalCosts from "./components/AdditionalCosts";
 import Equity from "./components/Equity";
 import Rate from "./components/Rate";
 import ModalView from "./components/ModalView";

  export default  {
    components: {
      ModalView,
      Rate,
      Equity, AdditionalCosts, NetLoan, SellingPrice, InterestInformation, AmortizationRate, FixedInterest},
    data() {
      return {
        rates:[
          1.50,2.00,2.50
        ],
        interests:[
          {
            year:5,
            rate:0.47
          },
          {
            year:10,
            rate:0.89
          },
          {
            year:11,
            rate:0.93
          },
        ],
        interestStorage:[],
        interest:0.52,
        interestAmortization:0,
        amortizationRate:2.0,
        sellingPrice:"350.000",
        additionalCosts:"40.740",
        netLoan:0,
        equity:"185.000",
        rate:0,
        showModal:false,
        sellingPriceChanged:false,
        loanRatio:0,
        currentSelectedYear:5
      };
    },
    watch:{
      sellingPrice(value){
        const eQ=this.reformatStringToNumber(this.equity);
        const sP=this.reformatStringToNumber(value);
        //check if sellingPrice is smaller than equity
        //if so change equity to the value of sellingPrice
        if (sP < eQ){
          this.equity = value;
        }
        //inform about change of sellingPrice and adjustment of additional costs
        if (!this.sellingPriceChanged){
          this.sellingPriceChanged = true;
          setTimeout(
              (scope)=>{
                scope.sellingPriceChanged = false;
              }
              ,4000,this);
          }
        }

    },
    methods:{
      loadTranslations(){
        this.$store.dispatch('translate');
      },
      loadCalculatorData(){

        fetch(process.env.VUE_APP_DATA_URI)
            .then((response)=>{
              if (response.ok) {
                return response.json();
              }
            }).then((data)=>{
              this.rates =data.rates;
              this.interests = this.catchInterests(data.interests);
              console.log('interests',this.interests);
              this.interest = this.interests[0].rate;
              this.currentSelectedYear = this.interests[0].year;
              this.interestStorage = data.interests;
              this.calculate();
            });
      },
      /**
       * Build the base interest to year select values
       **/
      catchInterests(rates){
        const rateStorage = [];

        for (let i=0;i<rates.length;i++){
          const localInterestStore = rates[i];
          rateStorage.push(
              {
                rate:localInterestStore.rates[0].interest,
                year:localInterestStore.year,
              }
          );
        }
        return rateStorage;

      },
      changeAmortizationRate(value){
        this.amortizationRate= value;
        this.calculate();
      },

      changeInterestRate(value){
        this.interest = value;
        //get the chosen year
        for (let i=0;i<this.interests.length;i++){
          if (parseFloat(this.interests[i].rate) === parseFloat(value)){
            this.currentSelectedYear = this.interests[i].year;
          }
        }

        this.calculate();
      },

      changeSellingPrice(value){
        this.sellingPrice = parseInt(value).toLocaleString('de-DE')
        this.calculate();

      },

      changeAdditionalCosts(value){
        this.additionalCosts = parseInt(value).toLocaleString('de-DE');
        this.calculate();
      },

      changeEquity(value){
        const sP=this.reformatStringToNumber(this.sellingPrice);

        this.equity = (sP < value) ?this.sellingPrice:parseInt(value).toLocaleString('de-DE');

        this.calculate();
      },
      /**
       * Starts the calculation process
       **/
      calculate(){
        this.netLoan =this.calculateNetLoan();
        this.calculateEquityRelatedInterest();
        this.calculateTotalInterest();
        this.rate = (this.interestAmortization)*parseInt(this.netLoan/100)/12;
      },

      calculateTotalInterest(){
        this.interestAmortization = (parseFloat(this.interest)+parseFloat(this.amortizationRate));
      },
      /**
       * The loan ratio is the ration between the sellingPrice in regard to the netLoan.
       * The smaller the ratio the better the interest.
       * i.e. ratio is 1.12 - you have no equity and the bank has to finance the additional costs also.
       * i.e. ratio is 0.5 - the netLoan has the size of the half selling Price and there
       * is enough equity to get the best interest.
       **/
      calculateEquityRelatedInterest(){

        const loanRatio = this.reformatStringToNumber(this.netLoan) / this.reformatStringToNumber(this.sellingPrice);
        let interest = 0;
        let interestObject = null;

        //if currentYear is selected and interestStorage not empty // else take the interest from
        if (this.currentSelectedYear!==0 && this.interestStorage.length){
          //get the right interestObject
          for (let i=0;i<this.interestStorage.length;i++){
            if (parseInt(this.interestStorage[i].year) === parseInt(this.currentSelectedYear)){
              interestObject = this.interestStorage[i];
              break;
            }
          }
          //get the right interest for the current loan ratio
          if (interestObject){
            for (let i=0;i<interestObject.rates.length;i++){
              if (interestObject.rates[i].ratio >= loanRatio){
                interest = interestObject.rates[i].interest;
                break;
              }
            }
            //if no interest than take the max value
            if (interest===0){
              interest = interestObject.max;
            }
            //set the current interest
            this.interest = interest;
          }
        }
        this.loanRatio = loanRatio.toFixed(2);
      },
      /**
       * calculate the net loan
       **/
      calculateNetLoan(){
        return this.reformatStringToNumber(this.sellingPrice)+
          this.reformatStringToNumber(this.additionalCosts)-
          this.reformatStringToNumber(this.equity);
      },

      reformatStringToNumber(value){
        return parseInt(String(value).replaceAll('.',''));
      },
      changeModal(){
        this.showModal = !this.showModal;
      },
      /**
       * the additional costs where calculated within the additional cost calculator and emitted to this view
       **/
      additionalCostCalculated(value){
        this.showModal = !this.showModal;
        this.additionalCosts = parseInt(value).toLocaleString('de-DE');
        this.calculate();
      },
      /**
       * if the selling price was changed, the additional costs where calculated again with the current stored values
       * @param value
       */
      additionalCostCalculatedAfterPriceChange(value){
        this.additionalCosts = parseInt(value).toLocaleString('de-DE');
        this.calculate();
      }
    },
    beforeMount() {
      this.loadTranslations();
      this.loadCalculatorData();
    },
    mounted() {
      this.calculate();
    }
  }
</script>
